import styled from 'styled-components';
import CaretDown from '#/shared/components/GeneratedIcons/generic/CaretDown';
import BaseCheckIcon from '#/shared/components/GeneratedIcons/generic/Check';

// TODO: move style applied to this component in the DateTimeSelector
//  here when ready to re-use that style throughout the app

export const InnerOptionWrapper = styled.div`
  display: flex;
  flex: 1 0 auto;
  justify-content: space-between;
  align-items: center;
`;

export const DropdownIcon = styled(CaretDown)`
  height: 1.25em;
  width: 1.25em;
`;

export const CheckIcon = styled(BaseCheckIcon).attrs(props => ({
  fill: props.theme.dropDownOptionSelectedCheck,
  height: 17,
}))`
  margin: 0 0 0 auto;
`;
